import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api-service';
import { BaseEntityService } from './base-entity';
import { StorageService } from './storage';
import { Product } from './products';

export interface PricelistItem {
  applied_on: '0_product_variant' | '1_product' | '2_product_category' | null;
  product_id: number;
  fixed_price: number;
}

export interface Pricelist {
  id: number;
  pricelist_name: string;
  items: PricelistItem[];
}

export function getPrice(pricelist: Pricelist | undefined, product: Product): number {
  if (!pricelist)
    return product.list_price;

  // Priority: Variant > Template > Category > fallback to product.list_price
  const items = pricelist.items;

  const byVariant = items.find(
    i => i.applied_on === '0_product_variant' && i.product_id === product.id
  );
  if (byVariant) return byVariant.fixed_price;

  const byTemplate = items.find(
    i => i.applied_on === '1_product' && i.product_id === product.templateId
  );
  if (byTemplate) return byTemplate.fixed_price;

  const byCategory = items.find(
    i => i.applied_on === '2_product_category' && i.product_id === product.categoryId
  );
  if (byCategory) return byCategory.fixed_price;

  return product.list_price; // fallback
}

@Injectable({
  providedIn: 'root'
})
export class PricelistService extends BaseEntityService<Pricelist> {
  constructor(
    indexedDbService: StorageService<Pricelist>,
    baseApi: BaseApiService
  ) {
    super(
      baseApi,
      indexedDbService,
      'PricelistDatabase',  // IndexedDB database name
      'pricelists',         // Object store name
      'pricelists'          // API endpoint path
    );
  }
}
